export class SucursalFilter {
   public nombre: string;
   public direccion: string;
   public activo: number;
   public emisorId: string;
   public usuarioId: string;
}
